import { Avatar, Button, Col, DatePicker, Row, Icon, Select } from 'antd'
import React, { useEffect, useState } from 'react'
import moment from 'moment';
import { useBoundStore } from '../../../../store/useBoundStore';
import { AGENCY_MANAGER, DATE_FORMAT, EA, LSP, SUPER_ADMIN } from '../../../../utils/Constants';
import { set } from 'lodash';
import { Translate } from 'react-translated';
import F from '../../../../Functions';
import { useRangePickerCloseButton } from '../../../../utils/rangePickerCloseButton';

const { RangePicker } = DatePicker;
const Option = Select.Option;
const dateFormat = DATE_FORMAT;
const today = new Date();

function EaDateFilter({ vonboard, review, is_lead, is_opportunity, show_lead_card_appointment_details, setState, state, loadStats, loadCardData, call_appointment_count, refreshStats, fetchAllBfiles,
    showAllBfiles = true

}) {
    const { AMDashboardFilter, userInfo } = useBoundStore();
    const [datemodified, setdatemodified] = useState({
        start_date: "2010-01-01",
        end_date: "2050-01-01",
        period: "from_to"
    })
    const [selectedButton, setSelectedButton] = useState(AMDashboardFilter.isAllBfiles);
    const [open, setOpen] = useState(false);
    useRangePickerCloseButton(open, setOpen);


    useEffect(() => {
        const myDateObj = localStorage.getItem("dateObj");
        const dateObjRecentExtRaC = localStorage.getItem("dateObjRecentExtRaC");
        const isAllBfiles = AMDashboardFilter.isAllBfiles !== false;

        // All B Files: prefer dashboard/agency defaults, not a leftover dateObj
        // (GlobalDashboard writes the shared dateObj key).
        if (isAllBfiles && !dateObjRecentExtRaC) {
            setdatemodified({
                start_date: state.start_date ? moment(state.start_date).format(dateFormat) : null,
                end_date: state.end_date ? moment(state.end_date).format(dateFormat) : null,
                period: state.period || "from_to"
            });
            setSelectedButton(true);
            return;
        }

        if (dateObjRecentExtRaC) {
            const parsedDateObj = JSON.parse(dateObjRecentExtRaC);

            // Create Moment objects from parsed dates and format them as MM.DD.YYYY
            const startDate = parsedDateObj.start_date ? moment(parsedDateObj.start_date).format(dateFormat) : null;
            const endDate = parsedDateObj.end_date ? moment(parsedDateObj.end_date).format(dateFormat) : null;

            // Set the dates only if valid, otherwise set to null
            setdatemodified({
                start_date: startDate,
                end_date: endDate,
                period: parsedDateObj.from_to || "from_to"
            });
        }

        else if (myDateObj != null && myDateObj) {
            const parsedDateObj = JSON.parse(myDateObj);

            // Create Moment objects from parsed dates and format them as MM.DD.YYYY
            const startDate = parsedDateObj.start_date ? moment(parsedDateObj.start_date).format(dateFormat) : null;
            const endDate = parsedDateObj.end_date ? moment(parsedDateObj.end_date).format(dateFormat) : null;

            // Set the dates only if valid, otherwise set to null
            setdatemodified({
                start_date: startDate,
                end_date: endDate,
                period: parsedDateObj.period || "from_to"  // Default to "from_to" if no period
            });
        } else {
            // If myDateObj is null or empty, use state values and format dates
            setdatemodified({
                start_date: state.start_date ? moment(state.start_date).format(dateFormat) : null,
                end_date: state.end_date ? moment(state.end_date).format(dateFormat) : null,
                period: state.period || "from_to"
            });
        }
    }, [state, AMDashboardFilter.isAllBfiles]);

    const onChangeDate = (date, name) => {
        const dateObjRecentExtRaC = localStorage.getItem("dateObjRecentExtRaC");
        if (date === null && name === "start_date") {

            setdatemodified(prevState => ({
                ...prevState,
                start_date: null,
                period: "from_to"
            }));
            const updatedDateObj = { start_date: null, end_date: datemodified.end_date, period: "from_to" };

            if (dateObjRecentExtRaC) {
                localStorage.setItem("dateObjRecentExtRaC", JSON.stringify(updatedDateObj));
            }
            localStorage.setItem("dateObj", JSON.stringify(updatedDateObj));



            useBoundStore.getState().setAMDashboardFilter({
                datemodified: {
                    start_date: datemodified.start_date || undefined,
                    end_date: undefined
                },
                isDateRangeClicked: true
            });


            useBoundStore.getState().setFsFilters({
                datemodified: {
                    start_date: datemodified.start_date || undefined,
                    end_date: undefined
                },
            });



            return;
        } else if (date === null && name === "end_date") {

            setdatemodified(prevState => ({
                ...prevState,
                end_date: null,
                period: "from_to"
            }));

            const updatedDateObj = { start_date: datemodified.start_date, end_date: null, period: "from_to" };
            if (dateObjRecentExtRaC) {
                localStorage.setItem("dateObjRecentExtRaC", JSON.stringify(updatedDateObj));
            }
            localStorage.setItem("dateObj", JSON.stringify(updatedDateObj));

            useBoundStore.getState().setAMDashboardFilter({
                datemodified: {
                    start_date: undefined,
                    end_date: datemodified.end_date || undefined
                },
                isDateRangeClicked: true
            });

            useBoundStore.getState().setFsFilters({
                datemodified: {
                    start_date: undefined,
                    end_date: datemodified.end_date || undefined
                },
            });

            return;
        } else {

            let { start_date, end_date, period } = datemodified

            date = date && moment(date).format("YYYY-MM-DD") || null
            start_date = start_date && moment(start_date).format("YYYY-MM-DD") || null
            end_date = end_date && moment(end_date).format("YYYY-MM-DD") || null

            let obj = {}

            if (['start_date', 'end_date'].includes(name) && !date) {

                start_date = moment(
                    new Date(today.getFullYear(), today.getMonth(), 1)
                ).format("YYYY-MM-DD");

                // end date
                end_date = moment(
                    new Date(today.getFullYear(), today.getMonth() + 1, 0)
                ).format("YYYY-MM-DD");

                period = "mtd";
                obj = { period }

                obj.start_date = start_date
                obj.end_date = end_date

            } else {
                period = "from_to";

                obj = { period }

                if (name === 'start_date' && date) {
                    obj.start_date = date
                    obj.end_date = end_date || moment(("2050-01-01")).format("YYYY-MM-DD");
                }
                if (name === 'end_date' && date) {
                    obj.end_date = date
                    obj.start_date = start_date || moment(("2010-01-01")).format("YYYY-MM-DD");
                }
            }
            if (dateObjRecentExtRaC) {
                localStorage.setItem("dateObjRecentExtRaC", JSON.stringify(obj))
            }
            localStorage.setItem("dateObj", JSON.stringify(obj))
            setdatemodified(obj);
            setState({ isAllBfiles: false, ...obj }, () => {
                setTimeout(async () => {
                    await call_appointment_count();
                    await loadCardData();
                    await loadStats();
                }, 1000);
            });

            useBoundStore.getState().setAMDashboardFilter({
                datemodified: {
                    start_date: obj.start_date || undefined,
                    end_date: obj.end_date || undefined
                },
                isDateRangeClicked: true,
                isAllBfiles: false
            });

            useBoundStore.getState().setFsFilters({
                datemodified: {
                    start_date: obj.start_date || undefined,
                    end_date: obj.end_date || undefined
                },
            });

            setSelectedButton(false);
        }
    }

    // const refreshStats = () => {
    //     useBoundStore.getState().setAMDashboardFilter({
    //         datemodified: {
    //             start_date: undefined,
    //             end_date: undefined
    //         }
    //     });
    //     let obj = {
    //         start_date: moment(new Date("2010-01-01")).format("YYYY-MM-DD"),
    //         end_date: moment(new Date("2050-01-01")).format("YYYY-MM-DD"),
    //         period: "from_to"
    //     }
    //     setdatemodified(obj);
    //     localStorage.setItem('user_t', "");
    //     localStorage.setItem('filter_lsp', "");
    //     localStorage.setItem("dateObj", JSON.stringify(obj))
    //     setState({ user_t: "", filter_lsp: "", isAllBfiles: true, ...obj }, () => {
    //         setTimeout(async () => {
    //             await this.call_appointment_count();
    //             await this.loadCardData();
    //             await this.loadStats();
    //         }, 1000);
    //     })
    // }

    const resetToAllBfiles = () => {
        useBoundStore.getState().setAMDashboardFilter({
            isAllBfiles: true
        });
        setSelectedButton(true);
    }

    return (
        <Row gutter={16} className='datepicker'
            style={{ display: 'flex', justifyContent: "flex-end", alignItems: "flex-end" }}
        // style={{ position: 'absolute', right: 20, top: 5, width: "350px", zIndex: 10 }}
        >

            {
                showAllBfiles && (
                    <Col>
                        <Button
                            className={`borderRadius-28 ${selectedButton ? "bgPrimary" : "bgGray"}`}
                            // className='borderRadius-28 btn-bg-164897'
                            onClick={() => {
                                resetToAllBfiles()
                                fetchAllBfiles()
                            }}
                        >
                            All B Files
                        </Button>
                    </Col>
                )
            }
            {
                userInfo && (
                    (userInfo.user_type === AGENCY_MANAGER ||
                    userInfo.user_type === SUPER_ADMIN) ||
                    (
                        [EA, LSP].includes(userInfo.user_type) &&
                        (review || is_lead || is_opportunity || show_lead_card_appointment_details)
                    )
                )

                    ? (
                        <Col className="date-picker-col">
                            <div className='datepicker-label' style={{ fontSize: 'x-small' }}>
                                Select Date Range</div>
                            <DatePicker.RangePicker
                                dropdownClassName="custom-range-picker" //for header
                                open={open}
                                //onOpenChange={(status) => setOpen(status)}
                                onOpenChange={(status) => {
                                    if (!status) return;
                                    setOpen(true);
                                }}
                                value={[
                                    datemodified.start_date ? moment(datemodified.start_date) : null,
                                    datemodified.end_date ? moment(datemodified.end_date) : null
                                ]}
                                format={dateFormat}
                                onChange={(dates) => {
                                    if (dates && dates.length === 2) {
                                        const start = dates[0].format("YYYY-MM-DD");
                                        const end = dates[1].format("YYYY-MM-DD");
                                        setdatemodified(prev => ({
                                            ...prev,
                                            start_date: start,
                                            end_date: end
                                        }));

                                        // onChangeDate(start, "start_date");
                                        // onChangeDate(end, "end_date");

                                    }
                                }}
                                renderExtraFooter={() => {
                                    const start = datemodified.start_date
                                        ? moment(datemodified.start_date)
                                        : moment();

                                    const end = datemodified.end_date
                                        ? moment(datemodified.end_date)
                                        : moment();

                                    return (
                                        <div style={{
                                            display: 'flex',
                                            justifyContent: 'space-between', gap: 20
                                        }}>

                                            {/* START CONTROLS */}
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                                                <div style={{ fontSize: 12, marginBottom: '-7px' }}>Start</div>

                                                <div style={{ display: "flex", gap: 6, marginBottom: '15px' }}>
                                                    <Select
                                                        showSearch
                                                        value={start.month()}
                                                        style={{ width: 100 }}
                                                        // className="dateRangedropDown custom-select"
                                                        onChange={(month) => {
                                                            const newDate = start.clone().month(month);
                                                            setdatemodified(prev => ({
                                                                ...prev,
                                                                start_date: newDate
                                                            }));
                                                        }}
                                                        filterOption={(input, option) =>
                                                            option.props.children &&
                                                            option.props.children.toString().toLowerCase().includes(input.toLowerCase())
                                                        }
                                                    >
                                                        {F.getMonthNames().map((m, i) => (
                                                            <Option key={i} value={i}>{m}</Option>
                                                        ))}
                                                    </Select>

                                                    <Select
                                                        showSearch
                                                        value={start.year()}
                                                        // className="dateRangedropDown custom-select"
                                                        style={{ width: 80 }}
                                                        onChange={(year) => {
                                                            const newDate = start.clone().year(year);
                                                            setdatemodified(prev => ({
                                                                ...prev,
                                                                start_date: newDate
                                                            }));
                                                        }}
                                                        filterOption={(input, option) =>
                                                            option.props.children &&
                                                            option.props.children.toString().toLowerCase().includes(input.toLowerCase())
                                                        }
                                                    >
                                                        {F.getYears().map((y) => (
                                                            <Option key={y} value={y}>{y}</Option>
                                                        ))}
                                                    </Select>
                                                </div>
                                            </div>

                                            {/* END CONTROLS */}
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                                                <div style={{ fontSize: 12, marginBottom: '-7px' }}>End</div>

                                                <div style={{ display: "flex", gap: 6, marginBottom: '15px' }}>
                                                    <Select
                                                        showSearch
                                                        value={end.month()}
                                                        style={{ width: 100 }}
                                                        // className="dateRangedropDown custom-select"
                                                        onChange={(month) => {
                                                            const newDate = end.clone().month(month);
                                                            setdatemodified(prev => ({
                                                                ...prev,
                                                                end_date: newDate
                                                            }));
                                                        }}
                                                        filterOption={(input, option) =>
                                                            option.props.children &&
                                                            option.props.children.toString().toLowerCase().includes(input.toLowerCase())
                                                        }
                                                    >
                                                        {F.getMomentMonths().map((m, i) => (
                                                            <Option key={i} value={i}>{m}</Option>
                                                        ))}
                                                    </Select>

                                                    <Select
                                                        showSearch
                                                        value={end.year()}
                                                        style={{ width: 80 }}
                                                        // className="dateRangedropDown custom-select"
                                                        onChange={(year) => {
                                                            const newDate = end.clone().year(year);
                                                            setdatemodified(prev => ({
                                                                ...prev,
                                                                end_date: newDate
                                                            }));
                                                        }}
                                                        filterOption={(input, option) =>
                                                            option.props.children &&
                                                            option.props.children.toString().toLowerCase().includes(input.toLowerCase())
                                                        }
                                                    >
                                                        {F.getYears().map((y) => (
                                                            <Option key={y} value={y}>{y}</Option>
                                                        ))}
                                                    </Select>
                                                </div>
                                            </div>

                                            {/* TODAY BUTTON */}
                                            <div
                                                style={{
                                                    alignSelf: 'center', cursor: 'pointer',
                                                    color: '#1890ff',
                                                    marginTop: '10px'
                                                }}
                                                onClick={() => {
                                                    const today = moment().format("YYYY-MM-DD");

                                                    setdatemodified(prev => ({
                                                        ...prev,
                                                        start_date: today,
                                                        end_date: today
                                                    }));

                                                    // setOpen(false);
                                                }}
                                            >
                                                Today
                                            </div>

                                            {/* VIEW BUTTON */}

                                            <div
                                                style={{
                                                    alignSelf: 'center'
                                                }}>
                                                <Button type="primary"
                                                    className="borderRadius-28 bg-164897"
                                                    style={{ marginTop: '15px' }}
                                                    onClick={() => {

                                                        setdatemodified(prev => ({
                                                            ...prev,
                                                            start_date: datemodified.start_date,
                                                            end_date: datemodified.end_date,
                                                        }));

                                                        // onChangeDate(datemodified.start_date, "start_date");
                                                        onChangeDate(datemodified.end_date, "end_date");

                                                        setOpen(false);
                                                    }}
                                                >
                                                    <Translate text={"Apply"}></Translate>
                                                </Button>
                                            </div>
                                        </div>
                                    );
                                }}
                            />
                        </Col>
                        // <Row gutter={16}>
                        //     <Col span={12}>
                        //         <div className='datepicker-label'>Start Date</div>
                        //         <DatePicker
                        //             value={datemodified.start_date ? moment(datemodified.start_date) : null}
                        //             format={dateFormat}
                        //             onChange={function (e) {
                        //                 var newDate = e ? e : moment();
                        //                 onChangeDate(newDate, 'start_date');
                        //             }}
                        //         />
                        //     </Col>

                        //     <Col span={12}>
                        //         <div className='datepicker-label'>End Date</div>
                        //         <DatePicker
                        //             value={datemodified.end_date ? moment(datemodified.end_date) : null}
                        //             format={dateFormat}
                        //             onChange={function (e) {
                        //                 var newDate = e ? e : moment();
                        //                 onChangeDate(newDate, "end_date");
                        //             }}
                        //         />
                        //     </Col>
                        // </Row>
                    ) : null
            }


            <Col>
                <Button
                    type='primary'
                    className='refresh-con'
                    onClick={() => {
                        resetToAllBfiles()
                        refreshStats()
                    }}
                >
                    <Icon type="reload" />
                </Button>
            </Col>
        </Row >
    )
}

export default EaDateFilter


// WEBPACK FOOTER //
// ./src/scenes/Dashboard/parts/EA_And_LSP/DateFilter.js